import React, { Component, useEffect, useState } from "react";

import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { PostApi } from "../../../js_assets/Network";
import axios from "axios";
import { api_url } from "../../../js_assets/ConfigApp";

import { GetApi } from "../../../js_assets/Network";

import CircularProgress from "@material-ui/core/CircularProgress";
import AssignmentInd from "@material-ui/icons/AssignmentInd";
import MonetizationOn from "@material-ui/icons/MonetizationOn";
import AppAdminContainer from "../AppAdminContainer";
import List from "@material-ui/core/List";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import Slide from "@material-ui/core/Slide";

import CloseIcon from "@material-ui/icons/Close";


import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TrainerRating from "./TrainerRating";
import SubscriptionOffer from "./SubscriptionOffer";
import TrainerRow from './TrainerRow'
function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const styles = (theme) => ({
  divider: {
    width: "100%",
  },
  ButtonGuide: {
    backgroundColor: "#74cbc4",
    color: "white",
    "&:hover": {
      background: "#74cbc4",
    },
    margin: theme.spacing.unit,
    padding: "5px",
    borderRadius: "5px",
    fontSize: 15,
    boxShadow: " 0 4px 8px 0 rgba(0,0,0,0.2);",
    fontFamily: ["DIN-NEXT™-ARABIC-BOLD"].join(","),
  },
  iocns: {
    fontSize: 18,
  },
  canceliocn: {
    color: "black",
    float: "left",
  },
  p_followUp_Schedule_Description: {
    maxWidth: 270,
    lineHeight: "2.7em",
  },
  ButtonSubscription: {
    backgroundColor: "#74cbc4",
    color: "white",
    "&:hover": {
      background: "#74cbc4",
    },
    fontSize: 15,
    boxShadow: " 0 4px 8px 0 rgba(0,0,0,0.2);",
    fontFamily: ["DIN-NEXT™-ARABIC-BOLD"].join(","),
  },
  btn_login: {
    color: "white",
    padding: "10px 1px",
    border: "none",
    cursor: "pointer",
    width: "100%",
    opacity: "0.9",
    borderRadius: "3px",
    fontFamily: ["DIN-NEXT™-ARABIC-BOLD"].join(","),
  },
  tab: {
    flexGrow: 1,
    marginTop: -5,
    backgroundColor: "#f7faea",
    fontFamily: ["DIN-NEXT™-ARABIC-BOLD"].join(","),
  },
  tab_button: {
    fontSize: 18,
    fontFamily: ["DIN-NEXT™-ARABIC-BOLD"].join(","),
  },
});

function Trainers(props) {
  
  const [trainer_data, setTrainer_data] = useState([]);
  const [followUp_Schedule_Data, setFollowUp_Schedule_Data] = useState([]);
  const [selected_followUp_Schedule_data, setSelected_followUp_Schedule_data] = useState([]);
  const { classes } = props;
  const [isloading, setIsloading] = useState(true);
  const [form_followUp_Schedule, setForm_followUp_Schedule] = useState(false);
  const [selected_tab, setSelected_tab] = useState(0);
  const [Open_DialogContent_trainer_Rating, setOpen_DialogContent_trainer_Rating] = useState(false);
  const [Open_DialogContentSubscriptionOffer, setOpen_DialogContentSubscriptionOffer] = useState(false);
  const [selectedTrainerId, setSelectedTrainerId] = useState(0);

  

  

  const Admin_Info = JSON.parse(localStorage.getItem("Admin_Info"))



  useEffect(() => {
    axios
      .get(`${api_url}/api/trainer/GetAllTrainers`)
      .then((result) => {
        setTrainer_data(result.data)

        setIsloading(false)
      })
      .catch(function (error) {
        //console.log(error);
      });

  }, []);




  const openfollowUp_Schedule=(trainer_Id)=> {
    setIsloading(true)
    axios
      .get(
        `${api_url}/api/trainer/Get_List_Schedule_Trainer_Admin/${trainer_Id}`
      )
      .then((result) => {
        //console.log(result.data)

        setFollowUp_Schedule_Data(result.data)
        setIsloading(false)
        setForm_followUp_Schedule(true)

      })
      .catch(function (error) {
        //console.log(error);
      });
  }

  const Edit_Subscription_Schedule = (followUp_Schedule_Id) => {
    setIsloading(true)
    axios
      .get(
        `${api_url}/api/trainer/Get_FollowUp_Schedule/${followUp_Schedule_Id}`
      )
      .then((result_data) => {
        setSelected_followUp_Schedule_data(result_data.data[0])
        setIsloading(false)
      })
      .catch(function (error) {
        //console.log(error);
      });
  };

  const Save_Subscription_Schedule = (e) => {
    e.preventDefault();


  };

  const redirectToUrl = (Component) => {
    window.location.href =
      window.location.protocol +
      "//" +
      window.location.hostname +
      ":" +
      window.location.port +
      Component;
  };



  const handleOpen_DialogContent_trainer_Rating = (TrainerID) => {

    setSelectedTrainerId(TrainerID)

    setOpen_DialogContent_trainer_Rating(true)
  };


  const handle_Open_DialogContentSubscriptionOffer = (TrainerID) => {
 

    setSelectedTrainerId(TrainerID)

    setOpen_DialogContentSubscriptionOffer(true)
  }

  const Delete_trainer = (ID) => {
 

    GetApi(
      `/api/Admin/DeleteTrainer/${ID}/${Admin_Info.admin_Id}`,
      Admin_Info.jwT_Token_Admin
    ).then(() => {
      alert("تم الحدف");
    });
  };

  const Delete_Schedule = (ID) => {
  

    GetApi(
      `/api/Admin/DeleteSchedule/${ID}/${Admin_Info.admin_Id}`,
      Admin_Info.jwT_Token_Admin
    ).then(() => {
      alert("تم الحدف");
    });
  };


  const handleClose_Reset_Password_From = () => {
    setForm_followUp_Schedule(false)
  };




  const handleClose_DialogContent_trainer_Active = () => {
  
    setOpen_DialogContent_trainer_Rating(false)
  };

  const handle_Close_DialogContent_SubscriptionOffer = () => {
   
    setOpen_DialogContentSubscriptionOffer(false)
  }

  const opne_CV = (file) => {
    window.open(`${api_url}/Content/Profile_Images/${file}`)
  }


  const tabChange = (event, selected_tab) => {
    setSelected_tab(selected_tab)
  };

  return (
    <AppAdminContainer Title={"المدربين"}>
      <div className="container">
        <div>
          <Grid container justify="center">
            <div>
              <button
                size="medium"
                variant="contained"
                className={classes.ButtonGuide}
                onClick={() =>
                  redirectToUrl(`/Admin/InvoiceTrainer?TrainerID=all`)
                }
              >
                جميع فواتير المدربين
              </button>
            </div>
          </Grid>
        </div>
        <Tabs
          variant="fullWidth"
          value={selected_tab}
          onChange={tabChange}
          className={classes.tab}
        >
          <Tab className={classes.tab_button} label="الحالين" />

          <Tab className={classes.tab_button} label="محذوفين" />
        </Tabs>
        <hr />
        <div>
          {isloading ?
            <div className="centerloadingicon">
              <CircularProgress />
            </div>
            : trainer_data.length == 0 ? null :
              selected_tab == 0 ?
                <TrainerRow
                  data={trainer_data.filter(e => e.is_Trainer_Deleted == false)}
                  handleOpen_DialogContent_trainer_Rating={handleOpen_DialogContent_trainer_Rating}
                  redirectToUrl={redirectToUrl}
                  openfollowUp_Schedule={openfollowUp_Schedule}
                  opne_CV={opne_CV}
                  handle_Open_DialogContentSubscriptionOffer={handle_Open_DialogContentSubscriptionOffer}
                  Delete_trainer={Delete_trainer}
                />
                :
                <TrainerRow
                  data={trainer_data.filter(e => e.is_Trainer_Deleted == true)}
                  handleOpen_DialogContent_trainer_Rating={handleOpen_DialogContent_trainer_Rating}
                  redirectToUrl={redirectToUrl}
                  openfollowUp_Schedule={openfollowUp_Schedule}
                  opne_CV={opne_CV}
                  handle_Open_DialogContentSubscriptionOffer={handle_Open_DialogContentSubscriptionOffer}
                  Delete_trainer={Delete_trainer}
                />


          }





          <Dialog
            fullWidth={"lg"}
            maxWidth={"lg"}
            fullScreen={true}
            open={form_followUp_Schedule}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">
              {" "}
              <label> جداول</label>
              <button
                onClick={handleClose_Reset_Password_From}
                className={classes.canceliocn}
                color="primary"
              >
                <CloseIcon />
              </button>
            </DialogTitle>

            <DialogContent>
              <List>
                {followUp_Schedule_Data.length === 0 ? (
                  <label>لايوجد جداول</label>
                ) : (
                  followUp_Schedule_Data.map((Schedule) => {
                    return (
                      <div>
                        <div className="w3-cell-row">
                          <div className="w3-cell w3-container">
                            <span
                              className="span12px"
                              style={{ color: "red" }}
                            >
                              {" "}
                              {Schedule.is_followUp_Schedule_Deleted === true
                                ? "محذوف"
                                : null}
                            </span>
                            <h4
                              style={
                                Schedule.is_followUp_Schedule_Deleted === true
                                  ? {
                                    textDecoration: "line-through",
                                    color: "red",
                                  }
                                  : null
                              }
                            >
                              {Schedule.followUp_Schedule_Name}
                            </h4>
                            <span className="span12px">السعر </span>{" "}
                            <span className="span12px">
                              {" "}
                              {Schedule.followUp_Schedule_Price} ريال
                            </span>
                            <br></br>
                            <span className="span12px">نوعه </span>{" "}
                            <span className="span12px">
                              {" "}
                              {Schedule.schedule_Package_Type_Name}{" "}
                            </span>
                            <br></br>
                            <span className="span12px">المده </span>{" "}
                            <span className="span12px">
                              {" "}
                              {Schedule.schedule_Duration} يوم
                            </span>
                            <p
                              className={
                                classes.p_followUp_Schedule_Description
                              }
                            >
                              {" "}
                              {Schedule.followUp_Schedule_Description}{" "}
                            </p>
                            <br></br>
                            <Grid
                              justify="center"
                              alignItems="center"
                              container
                              spacing={8}
                            >
                              <Grid item xs>
                                <button
                                  size="medium"
                                  variant="contained"
                                  color="primary"
                                  className={classes.ButtonSubscription}
                                  onClick={() =>
                                    redirectToUrl(
                                      `/Admin/Subscription_Schedule_Trainer?Edit=${Schedule.followUp_Schedule_Id}`
                                    )
                                  }
                                >
                                  تعديل
                                </button>
                              </Grid>

                              <Grid item xs>
                                <button
                                  size="small"
                                  variant="contained"
                                  style={{ backgroundColor: "red" }}
                                  className={classes.ButtonSubscription}
                                  onClick={() => {
                                    if (
                                      window.confirm(
                                        "هل متاكد انك تبغى تحدف  ؟؟"
                                      )
                                    )
                                      Delete_Schedule(
                                        Schedule.followUp_Schedule_Id
                                      );
                                  }}
                                >
                                  حذف
                                </button>
                              </Grid>
                            </Grid>
                          </div>
                        </div>
                        <hr className={classes.divider}></hr>
                      </div>
                    );
                  })
                )}
              </List>
            </DialogContent>
          </Dialog>
        </div>


        {
          Open_DialogContent_trainer_Rating &&
          <TrainerRating
            handleClose_DialogContent_trainer_Active={handleClose_DialogContent_trainer_Active}
            TrainerID={selectedTrainerId}
          />
        }

        {
          Open_DialogContentSubscriptionOffer &&
          <SubscriptionOffer
            handle_Close_DialogContent_SubscriptionOffer={handle_Close_DialogContent_SubscriptionOffer}
            TrainerID={selectedTrainerId} />
        }



      </div>
    </AppAdminContainer >
  );
}

Trainers.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Trainers);
